import React from "react";
import withIconComponent from "../withIconComponent";

var Lock = function Lock() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C9.2 1 7 3.2 7 6v3h10V6c0-2.8-2.2-5-5-5zM4 9h16v14H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13a2 2 0 1 0 0 4 2 2 0 1 0 0-4zM12 17v2",
    "data-color": "color-2"
  }));
};

export default withIconComponent("UiLock", false)(Lock);